import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {MasterClassService} from "../../../services/masterClassService/masterClassService";
import {PageErrorMessage} from "../../../components/PageErrorMessage";
import Loader from "../../../components/common/Loader";
import TextEditorContent from "../../../components/TextEditorContent";
import MasterClassLessonsList from "./MasterClassLessonsList";
import notFound from "../../../assets/not-found/not_found.png";
import UserDetails from "../../../components/UserDetails";
import SpeakerBio from "./SpeakerBio";
import Tags from "../../../components/Tags/Tags";
import YoutubeSession from "../../dashboard/components/YoutubeSession";
import RecordedVideoSession from "../../dashboard/components/RecordedVideoSession";

const PreviewMasterClass = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [masterClassDetails, setMasterClassDetails] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const masterClassDetailsData = async () => {
        setIsLoading(true);
        try {
            await MasterClassService.getMasterClassPreviewData(id).then((response) => {
                setMasterClassDetails(response?.data);
            });

            setIsLoading(false);
        } catch (error) {
            setError({
                statusCode: error.response.status,
                message: error.response.data.message,
            });
            setIsLoading(false);
        }
    };

    // useEffect of call all api function
    useEffect(() => {
        masterClassDetailsData();
    }, [id]);

    if (error) {
        return <PageErrorMessage
            error={error}
            entityTitle="Masterclass"
        />;
    }

    return (
        <>
            {isLoading ? (
                <>
                    <Loader/>
                </>
            ) : (
                <>
                    <div className="container m-4">
                        <div className="row mb-5">
                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>{masterClassDetails?.name}</h1>
                                {masterClassDetails?.tags.length > 0 &&
                                    <div className="mt-2 mb-2">
                                        <Tags
                                            tags={masterClassDetails?.tags}
                                        />
                                    </div>
                                }
                                <TextEditorContent
                                    text={masterClassDetails?.description}
                                />
                                <div className="mt-3">
                                    {masterClassDetails?.lessons.length > 0 &&
                                        <MasterClassLessonsList
                                            lessons={masterClassDetails?.lessons}
                                            withProgress={false}
                                            isPreview={true}
                                        />
                                    }
                                    {masterClassDetails?.lessons.length === 0 &&
                                        <div
                                            className="w-100 mt-3 rounded-4 text-center d-flex flex-column align-items-center justify-content-center"
                                            style={{height: "500px"}}>
                                            <img crossOrigin="anonymous" src={notFound} alt="data not found" width={300}/>
                                            <h3>No Lessons Added</h3>
                                            <p className="fs-5">No lessons available at the moment.</p>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="master-class__image">
                                    {masterClassDetails?.trailer_url ? (
                                        <YoutubeSession video={masterClassDetails?.trailer_url} />
                                    ) : masterClassDetails?.trailer_link ? (
                                        <RecordedVideoSession video={masterClassDetails?.trailer_link} />
                                    ) :
                                        <img
                                            src={masterClassDetails?.cover_image}
                                            alt={masterClassDetails?.name}
                                            className="img-fluid"
                                        />
                                    }
                                </div>
                                <div className="master-class__speaker-info p-3 mt-3">
                                    <div className="d-flex justify-content-center align-items-center flex-column">
                                        <div onClick={() => navigate(`/community/users/${masterClassDetails?.speaker.id}`)}>
                                            <UserDetails user={masterClassDetails?.speaker} />
                                        </div>
                                        <div className="mt-1">
                                            {masterClassDetails?.speaker?.bio && <SpeakerBio bio={masterClassDetails.speaker.bio} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PreviewMasterClass;